/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentEditor } from "@tiptap/react";
import { useCallback } from "react";
import { isGuid } from "utils/empty-exists";

const useUpdateImage = () => {
    
    const markType = "image";
    const { editor } = useCurrentEditor();
    const image = editor.getAttributes(markType);
    
    // state of
    // const [visible,setVisible] = useState(false)
    
    // const [selection,setSelection] = useState(editor?.view?.state?.selection)
    // const [selectedText,setSelectedText] = useState(editor?.view?.state?.selection?.node?.text)
    
    const updateImage = useCallback(
        (image, settings) => {
            
            const {
                guid,
                title,
                alt,
                description: caption, // we using caption attribute in preview/dnv website. Because we saved caption as description field in image record
                url,
                file_name,
                file_size,
                // ext,
                width,
                // height,
            } = image ||{};
            
            if (isGuid(guid)) {
                
                const imageData = {
                    guid,
                    src: url,
                    url,
                    title,
                    alt,
                    caption,
                    file_name,
                    file_size,
                    width: width > 0 ? width : "100%",
                    // height,
                    settings
                };
                
                editor.chain().focus().setImage( imageData ).run();
                
            }
        },
        [editor],
    );

    return {
        image,
        updateImage,
    };
};

export { useUpdateImage };
